<template>
  <vs-popup
    v-if="passData !== null"
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Root</strong></h6>
        </section>
        <vs-input
          class="w-full sidebar-input"
          v-model="formData.root"
          placeholder="Isi Dengan Root"
        />
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Icon</strong></h6>
        </section>
        <vs-input
          class="w-full sidebar-input"
          v-model="formData.icon"
          placeholder="Isi Dengan Icon"
        />
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button color="success" class="ml-2 rounded-2xl" @click="addWithOption">{{
          labelButton
        }}</vs-button>
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    jenis: { type: Number, default: 1 },
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      priceSelect: false,
      binaryFile: "",
      formData: {
        icon: "",
        root: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.jenis === 1
        ? "Edit Root Icon Kategori ZIS"
        : this.jenis === 2
        ? "Edit Root Icon Kategori Campaign"
        : "Edit Root Icon Kategori SOS";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.description !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData === null) {
        this.resetForm();
      } else {
        this.formData.icon = this.passData.icon;
        this.formData.root = this.passData.root;
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.icon = "";
      this.formData.root = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      if (this.jenis === 1) {
        this.addKatZIS(this.passData);
      } else if (this.jenis === 2) {
        this.addKatCampaign(this.passData);
      } else {
        this.addKatSOS(this.passData);
      }
    },
    addKatZIS(data) {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("zis/cudKatZIS", [
          {
            price_custom: data.price_custom,
            name: data.name,
            description: data.description,
            file: data.file,
            root: this.formData.root,
            icon: this.formData.icon,
            ...id,
          },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kategori ZIS Sukses!"
                : "Tambah Kategori ZIS Sukses!",
            text:
              this.passData !== null
                ? `Kategori ZIS ${v.name} Berhasil diedit`
                : `Kategori ZIS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    addKatCampaign(data) {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("campaign/cudKatCampaign", [
          {
            name: data.name,
            description: data.description,
            root: this.formData.root,
            icon: this.formData.icon,
            ...id,
          },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kategori Campaign Sukses!"
                : "Tambah Kategori Campaign Sukses!",
            text:
              this.passData !== null
                ? `Kategori Campaign ${v.name} Berhasil diedit`
                : `Kategori Campaign ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    addKatSOS(data) {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("sos/cudKategoriSOS", [
          {
            name: data.name,
            description: data.description,
            file: data.file,
            root: this.formData.root,
            icon: this.formData.icon,
            ...id,
          },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kategori SOS Sukses!"
                : "Tambah Kategori SOS Sukses!",
            text:
              this.passData !== null
                ? `Kategori SOS ${v.name} Berhasil diedit`
                : `Kategori SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
